import {
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  DialogActions,
} from "@material-ui/core";

import Button from "../Button";
import { ClearBulkTicketsDialogProps } from "../../../interface/dialog/ClearBulkTicketsDialogProps";
import { useDialogStyles } from "./styles";

const ConfirmBulkClearDialog = ({
  open,
  onClose,
  onConfirmSubmit,
  response,
}: ClearBulkTicketsDialogProps) => {
  const classes = useDialogStyles();
  return (
    <Dialog open={open} onClose={() => onClose()} fullWidth maxWidth="sm">
      <DialogTitle className={classes.dialogTitle}>
        {"Confirm Bulk Clear?"}
      </DialogTitle>
      <DialogContent className={classes.dialogContent}>
        <div className={classes.stackedContent}>
          <Typography>
            Are you sure you want to proceed and clear out selected ticket
            values?
          </Typography>
          <Typography>
            Excluded tickets ({response?.excludedTicketNumbers.length}):{" "}
            {Number(response?.excludedTicketNumbers?.length) > 0
              ? response?.excludedTicketNumbers.join(",")
              : "none"}
          </Typography>
          {response && response?.ticketNumbers?.length > 0 ? (
            <>
              <Typography>
                {response.ticketNumbers.length} {"ticket(s)"} will be cleared:
              </Typography>

              {response &&
                response.results.map((result, index) => {
                  return (
                    <Typography key={index}>
                      <b>{result.key}</b> {result.value}
                    </Typography>
                  );
                })}
            </>
          ) : (
            <Typography>{"No ticket conflict's were found."}</Typography>
          )}
        </div>
      </DialogContent>
      <DialogActions className={classes.dialogActions}>
        <div className={classes.actionButton}>
          <Button
            label="Cancel"
            onClick={() => onClose()}
            color="default"
            variant="contained"
            type="button"
          />
        </div>
        <div className={classes.actionButton}>
          <Button
            label="Clear Selected"
            onClick={() => onConfirmSubmit()}
            autoFocus
            color="primary"
            variant="contained"
            type="button"
          />
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmBulkClearDialog;
